/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type CancelContextResponseCadence = typeof CancelContextResponseCadence[keyof typeof CancelContextResponseCadence] | null;


export const CancelContextResponseCadence = {
  monthly: 'monthly',
  annual: 'annual',
} as const;
